const TeamRolePerspectives = {
    PERSONALITY: 'zij',
    AMBITION: 'wil'
};

export default TeamRolePerspectives;
